// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1PYvJ","footer":"ModalError_footer__2zjde"};